import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class AddressService {
	constructor(private _http: HttpClient) {
	}

	/**
	 * @api {post} /v2/InetAddresses Create Address
	 * @apiName createAddress
	 * @apiParam {boolean} [allowDuplicate] Allow Duplicate
	 * @apiGroup InetAddresses
	 * @apiVersion 20.0.0
	 */
	createAddress(address, allowDuplicate) {
		let params: HttpParams = new HttpParams();
		if (allowDuplicate) {
			params = params.append('allowDuplicate', allowDuplicate);
		}
		return this._http.post<any>(`${environment.apiUrl}/v2/InetAddresses`, address, {params});
	}

	/**
	 * @api {delete} /v2/InetAddresses/:id Delete Address
	 * @apiName deleteAddress
	 * @apiGroup InetAddresses
	 * @apiVersion 20.0.0
	 */
	deleteAddress(id) {
		return this._http.delete<any>(`${environment.apiUrl}/v2/InetAddresses/${id}`);
	}

	/**
	 * @api {get} /v2/InetAddresses/:id Get Address
	 * @apiName getAddress
	 * @apiGroup InetAddresses
	 * @apiVersion 20.0.0
	 */
	getAddress(id) {
		return this._http.get<any>(`${environment.apiUrl}/v2/InetAddresses/${id}`);
	}

	/**
	 * @api {post} /v2/InetAddresses/RolodexSearch Get Addresses By Search Paginated
	 * @apiName getAddressesRefined
	 * @apiParam {number} [pageNum] Page Number
	 * @apiParam {number} [pageSize] Page Size
	 * @apiParam {boolean} [rolodexSearch] Whether this is a rolodex search
	 * @apiParam {boolean} [includeTotalCount] Whether to include total count
	 * @apiGroup InetAddresses
	 * @apiVersion 20.0.0
	 */
	getAddressesRefined(criteria, pageNum, pageSize, rolodexSearch) {
		let params: HttpParams = new HttpParams();
		if (pageNum) {
			params = params.append('pageNum', pageNum);
		}
		if (pageSize) {
			params = params.append('pageSize', pageSize);
		}
		if (rolodexSearch) {
			params = params.append('rolodexSearch', rolodexSearch);
		}
		return this._http.post<any>(`${environment.apiUrl}/v2/InetAddresses/RolodexSearch`, JSON.stringify(criteria), {params});
	}

	/**
	 * @api {post} /v2/InetAddresses/Search Get Addresses By Search
	 * @apiName searchAddresses
	 * @apiParam {number} [pageSize] Page Size
	 * @apiParam {number} [pageNum] Page Number
	 * @apiParam {string} [sortColumn] Sort Column
	 * @apiParam {string} [sortDirection] Sort Direction
	 * @apiGroup InetAddresses
	 * @apiVersion 20.0.0
	 */
	searchAddresses(criteria, pageNum?, pageSize?, sortColumn?, sortDirection?, searchColumns?: any[]) {
		const body = [];
		let params: HttpParams = new HttpParams();
		if (pageNum) {
			params = params.append('pageNum', pageNum);
		}
		if (pageSize) {
			params = params.append('pageSize', pageSize);
		}
		if (sortColumn) {
			params = params.append('sortColumn', sortColumn);
		}
		if (sortDirection) {
			params = params.append('sortDirection', sortDirection);
		}
		// Limit search by these columns NAME, ADDRESS, ADDRESS2 CITY, STATE, ZIP unless search columns is included then use those
		if (searchColumns) {
			for (const col of searchColumns) {
				body.push({
					searchColumn: col,
					searchValues: [criteria.toString()]
				});
			}
		} else {
			const columns = ['NAME', 'ADDRESS', 'ADDRESS2', 'CITY', 'STATE', 'ZIP'];
			for (const col of columns) {
				body.push({
					searchColumn: col,
					searchValues: [criteria.toString()]
				});
			}
		}
		return this._http.post<any>(`${environment.apiUrl}/v2/InetAddresses/Search`, body, {params});
	}

	/**
	 * @api {put} /v2/InetAddresses/:id Update Address
	 * @apiName updateAddress
	 * @apiGroup InetAddresses
	 * @apiVersion 20.0.0
	 */
	updateAddress(address, id) {
		return this._http.put<any>(`${environment.apiUrl}/v2/InetAddresses/${id}`, address);
	}

	/**
	 * @api {post} /v2/InetAddresses/Validate Validate Address
	 * @apiName validateAddress
	 * @apiGroup InetAddresses
	 * @apiVersion 20.0.0
	 */
	validateAddress(street1, city, state, zip, country) {
		const address = {
			streetAddress1: street1,
			city: city,
			province: state,
			postalCode: zip,
			countryCode: country.toString() // Yeah another fn number has to be a string :/
		};
		return this._http.post<any>(`${environment.apiUrl}/v2/InetAddresses/Validate`, address);
	}
}
